/* eslint-disable no-unused-vars */
import { all, put, takeEvery } from "redux-saga/effects";
import { watchUser } from "Features/user";
import { watchCountryList, watchTimezone, watchUserMails } from "Features/utils";
import { authActions, watchAuth } from "Features/auth";
import { watchBalance } from "Features/balance";
import { watchWallets } from "Features/wallets";
import { watchPayHistory } from "Features/pay_history";
import { languageActions, watchLanguage } from "Shared/store/language";
import { watchError } from "Features/error";
import { watchTax } from "Pages/Withdraw/store";

function* appInit() {
	yield put(languageActions.getList());
	yield put(authActions.check());
}

function* watchInit() {
	yield takeEvery("persist/REHYDRATE", appInit);
}

export default function* rootSaga() {
	yield all([
		watchUser(),
		watchUserMails(),
		watchCountryList(),
		watchTimezone(),
		watchAuth(),
		watchBalance(),
		watchWallets(),
		watchPayHistory(),
		watchLanguage(),
		watchInit(),
		watchError(),
		watchTax(),
	]);
}
